'use strict';

angular.module('shiftTraderApp')
    .directive('saEmployeeCard', function () {
      return {
        templateUrl: 'views/directives/saEmployeeCard.html',
        restrict: 'A',
        require: '^saMassUsersPositionEditor',
        replace: true,
        scope: {
          me:'=loggedInUser',
          org:'=',
          position: '=',
          emp: '=employee',
          active: '=',
          sortOrder: '='
        },
        link: function(scope, element, attrs, saMassUsersPositionEditor) {
          scope.parentCtrl = saMassUsersPositionEditor;
        },
        controller: ['$scope', '$q', '$timeout', 'Positions', 'Departments', 'UsersPositions', function($scope, $q, $timeout, Positions, Departments, UsersPositions) {
          var syncWatchProperties = [
            'training',
            'ranking'
          ];

          var genSyncWatchPropertiesDict = function(props, initValue) {
            var temp = {};

            _.each(props, function(prop) {
              temp[prop] = initValue;
            });

            return temp;
          };

          $scope.state = {
            hasPosition: false,
            ratingViewVisible: false,
            allSyncd: true,
            syncd: genSyncWatchPropertiesDict(syncWatchProperties, true),
            lastSyncd: genSyncWatchPropertiesDict(syncWatchProperties, ''),
            justSyncd: false,
            q: {}
          };

          var justSyncdTimeout;

          // set lastSyncd to exactly what the server told us the last known value is
          var setLastSyncd = function(props, up, ignoreJustSynced) {
            _.each(props, function(prop) {
              $scope.state.lastSyncd[prop] = up[prop];
              $scope.state.syncd[prop] = ($scope.state.lastSyncd[prop] == up[prop]);// jshint ignore:line
            });

            if (_.isUndefined(ignoreJustSynced)) {
              $scope.state.justSyncd = true;

              if (!_.isUndefined(justSyncdTimeout)) {
                $timeout.cancel(justSyncdTimeout);
              }

              justSyncdTimeout = $timeout(function () {
                $scope.state.justSyncd = false;
              }, 3000);
            }
            $scope.state.allSyncd = _.all($scope.state.syncd);
          };

          $scope.updateInProgress = false;

          var initializing;

          var updateWatchProperties = [
            'state.hasPosition',
            'usersPosition.training'
          ];

          var previousRanking;
          $scope.$watch('state.ratingViewVisible', function(newVal, oldVal) {
            if (newVal !== oldVal) {
              if (oldVal && (previousRanking != $scope.usersPosition.ranking)) { // jshint ignore:line
                updateFunction();
              } else {
                previousRanking = Number($scope.usersPosition.ranking);
              }
            }
          });

          var updateWatchPropertiesDestroyMethods = [];
          var init = function() {
            _.forEach(updateWatchPropertiesDestroyMethods, function(method) {
              if (!_.isUndefined(method)) {
                method();
              }
            });

            initializing = updateWatchProperties.length;
            $scope.usersPosition = _.find($scope.emp.users_positions, function(up) {
              return up.position_id === $scope.position.id;
            });

            $scope.state.hasPosition = !_.isUndefined($scope.usersPosition) && $scope.usersPosition.active;

            if (_.isUndefined($scope.usersPosition)) {
              $scope.usersPosition = {
                id: null,
                user_id: $scope.emp.id,
                organization_id: $scope.position.organization_id,
                position_id: $scope.position.id,
                training: false,
                ranking: 0
              };
            }

            setLastSyncd(syncWatchProperties, $scope.usersPosition, true);
            if ($scope.state.hasPosition) {
              setupSyncWatchers();
            }

            $scope.state.ratingViewVisible = false;
            $scope.state.hasCustomWage = false;

            if (!_.isUndefined(justSyncdTimeout)) {
              $timeout.cancel(justSyncdTimeout);
              $scope.state.justSyncd = false;
            }

            $scope.updateInProgress = false;
            $scope.updateQueued = false;

            updateWatchPropertiesDestroyMethods = _.map(updateWatchProperties,
              function(prop) {
                return $scope.$watch(prop, function() {
                  updateFunction();
                });
              });
          };

          var syncWatchGenerator = function(prop) {
            return function(newVal) {
              //console.log('SYNCWATCH-GENERATOR-RUNNING: ' + prop);
              //console.log($scope.state.lastSyncd);
              //console.log(prop, $scope.state.lastSyncd[prop], newVal);
              $scope.state.syncd[prop] = ($scope.state.lastSyncd[prop] == newVal); // jshint ignore:line
              $scope.state.allSyncd = _.all($scope.state.syncd);
            };
          };


          var syncWatchers;

          var setupSyncWatchers = function() {
            //console.log('setupSyncWatchers');
            syncWatchers = _.map(syncWatchProperties, function(p) {
              return $scope.$watch('usersPosition.' + p, syncWatchGenerator(p));
            });
          };

          var removeSyncWatchers = function() {
            _.each(syncWatchers, function(watcher) {
              watcher();
            });
          };

          var setSortOrder = function(name) {
            $scope.emp._topName = (name === 'first' ? $scope.emp.first_name : $scope.emp.last_name + ',');
            $scope.emp._bottomName = (name === 'last' ? $scope.emp.first_name : $scope.emp.last_name);
          };

          setSortOrder('first');

          $scope.state.q.drawerOpen = function() {
            return $scope.state.ratingViewVisible;
          };

          var makeActive = function() {
            $scope.parentCtrl.setActiveEmp($scope.emp);
          };

          var makeInactive = function() {
            closeDrawer();
          };

          var closeDrawer = function() {
            $scope.state.ratingViewVisible = false;
          };

          $scope.$watch('position.id', function() {
            init();
          });

          $scope.$watch('active', function() {
            if (!$scope.active) {
              makeInactive();
            }
          });

          $scope.$watch('sortOrder', function() {
            setSortOrder($scope.sortOrder);
          });

          $scope.$on('setEmpSelection', function(event, data) {
            $scope.state.hasPosition = data;
          });


          $scope.toggleSelected = function() {

            if ($scope.state.q.drawerOpen()) {
              closeDrawer();
            } else {
              makeActive();
              $scope.state.hasPosition = !$scope.state.hasPosition;
              if ($scope.state.hasPosition) {
                if (_.isUndefined($scope.usersPosition)) {
                  $scope.usersPosition = {
                    id: null,
                    user_id: $scope.emp.id,
                    organization_id: $scope.position.organization_id,
                    position_id: $scope.position.id,
                    training: false,
                    ranking: 0
                  };

                  $scope.state.lastSyncd.training = false;
                  $scope.state.lastSyncd.ranking = 0;
                }
                setupSyncWatchers();
              } else {
                removeSyncWatchers();
                closeDrawer();
              }
            }
          };

          $scope.toggleTraining = function () {
            makeActive();
            $scope.usersPosition.training = !$scope.usersPosition.training;
//            logEmp();
          };

          $scope.toggleRatingView = function() {
            makeActive();
            $scope.state.ratingViewVisible = !$scope.state.ratingViewVisible;
          };

          var sendUpdateRequest = function() {
            if ($scope.state.hasPosition) {
              var data = {
                position_id: $scope.position.id,
                user_id: $scope.emp.id,
                organization_id: $scope.position.organization_id,
                active: true,
                training: $scope.usersPosition.training,
                ranking: $scope.usersPosition.ranking
              };

              if (!$scope.usersPosition.training) {
                data.training_completion_date = moment.utc().format();
              } else {
                data.training_completion_date = null;
              }
              $scope.updateInProgress = true;
              UsersPositions.create(data)
                  .then(function(responseData) {
                    if (!$scope.state.updateQueued) {
                      var matchIdx = 0;

                      while (matchIdx > -1) {
                        matchIdx = _.findIndex($scope.emp.users_positions, {position_id: responseData.position_id});

                        if (matchIdx > -1) {
                          $scope.emp.users_positions.splice(matchIdx, 1);
                        }
                      }

                      $scope.usersPosition = responseData;
                      $scope.emp.users_positions.push(responseData);
                      setLastSyncd(syncWatchProperties, $scope.usersPosition);
                      $scope.updateInProgress = false;
                      $scope.parentCtrl.requestCompleted();
                    }
                  });
            } else if (!_.isUndefined($scope.usersPosition)) {
              var dataForRequest = {
                id: $scope.usersPosition.id,
                position_id: $scope.position.id,
                user_id: $scope.emp.id,
                organization_id: $scope.position.organization_id,
                active: false
              };
              $scope.updateInProgress = true;
              UsersPositions.update(dataForRequest)
                  .then(function(responseData) {
                    if (!$scope.state.updateQueued) {
                      $scope.usersPosition = responseData;
                      setLastSyncd(syncWatchProperties, $scope.usersPosition);
                      var idx = _.findIndex($scope.emp.users_positions, {position_id: responseData.position_id});
                      if (idx > -1) {
                        $scope.emp.users_positions[idx] = responseData;
                      } else {
                        $scope.emp.users_positions.push(responseData);
                      }
                      $scope.updateInProgress = false;
                      $scope.parentCtrl.requestCompleted();
                    }
                  });
            }
          };

          var updateFunction = function () {
            if (initializing > 0) {
              // initializing is set according to the number of watches that are going to fire at controller instantiation
              initializing -= 1;
            } else {
              // executes after controller instantiation (watches all fired once)
              if ($scope.state.updateInProgress) {
                // if an update is in progress then set the queued flag
                //   AND watch for the updateInProgress flag to unset so that you can send the request
                $scope.state.updateQueued = true;
                var terminateWatch = $scope.$watch($scope.state.updateInProgress, function () {
                  if (!$scope.state.updateInProgress) {
                    sendUpdateRequest();
                    terminateWatch();
                    $scope.state.updateQueued = false;
                  }
                });
              } else {
                // most common case... no update in progress, just fire off the request
                sendUpdateRequest();
              }
            }
          };

        }]
      };
    });
